import { writable } from "svelte/store";

// const ItemStore = writable([]);
// export default ItemStore;

// ITEMSTORE
const Items = writable(JSON.parse(localStorage.getItem("DATA")) || "");
Items.subscribe((value) => localStorage.setItem("DATA", JSON.stringify(value)));

export default Items;
